// extracted by mini-css-extract-plugin
export default {"moreBtn":"moreBtn__1GTV79AaC3cll4lBampnPx"};